$shm_hitalama_profile_badge $mol_view
	avatar_uri \
	name \
	sub /
		^ avatar_visible / <= Avatar $mol_image
			uri <= avatar_uri
		<= Name $mol_view
			sub / <= name

